if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log(MutationList);
      for (let item of MutationList) {
        if (item.target.id === "cart-icon-bubble") {
          BSS_B2B.observer.cartSubject.listenCartCheckout();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
}
